import React, { useLayoutEffect, useRef, useState } from "react";

const values = [
  {
    title: "Vision",
    description:
      "To connect the world's stage. By bridging the performing arts community with innovative social technology and industry-leading insights, we achieve scale like never before.",
  },
  {
    title: "Mission",
    description:
      "A vibrant, inspiring home. We foster a trusted, non-toxic, and supportive community for artists and audiences to discover, collaborate, and celebrate the power of live performance through HereWeAre.",
  },
  {
    title: "Goal",
    description:
      "To build the preeminent global platform for the performing arts by 2027. HereWeAre will host the industry's most comprehensive database, fueling a thriving, borderless community that inspires creators and arts lovers worldwide.",
  },
];

export default function AboutSection() {
  const statementRef = useRef<HTMLSpanElement>(null);
  const stagePhraseRef = useRef<HTMLSpanElement>(null);
  const [stageWrapped, setStageWrapped] = useState(false);

  useLayoutEffect(() => {
    const statement = statementRef.current;
    const stagePhrase = stagePhraseRef.current;
    if (!statement || !stagePhrase) return;

    // 실제 문구 폭에 따른 조건부 줄바꿈 판별
    const updateStageWrap = () => {
      const leadingText = statement.firstChild;
      if (!(leadingText instanceof Text)) return;

      const range = document.createRange();
      range.selectNodeContents(leadingText);
      const leadingRects = Array.from(range.getClientRects());
      const lastLeadingRect = leadingRects[leadingRects.length - 1];
      if (!lastLeadingRect) return;

      const lineHeight = parseFloat(getComputedStyle(statement).lineHeight);
      const wrapped =
        stagePhrase.getBoundingClientRect().top - lastLeadingRect.top >
        lineHeight / 2;
      setStageWrapped((current) => (current === wrapped ? current : wrapped));
    };

    const resizeObserver = new ResizeObserver(updateStageWrap);
    resizeObserver.observe(statement);
    updateStageWrap();
    document.fonts?.ready.then(updateStageWrap);

    return () => resizeObserver.disconnect();
  }, []);

  return (
    <section className="about-hwa">
      <div className="about-hwa__heading">
        <h2>
          <span className="about-hwa__eyebrow">About HereWeAre</span>
          <span
            ref={statementRef}
            className={`about-hwa__statement about-hwa__statement--lead${
              stageWrapped ? " is-stage-wrapped" : ""
            }`}
          >
            A purpose-built platform{" "}
            <span ref={stagePhraseRef} className="about-hwa__stage-phrase">
              for&nbsp;
              <span className="about-hwa__accent">
                <em>the&nbsp;stage</em>
                <i>,</i>
              </span>
            </span>
            <br className="about-hwa__wide-break" />{" "}
            <b>by the artists who shape it.</b>
          </span>
        </h2>
        <p>
          HereWeAre is the first purpose-built, global, artist-led community. We
          connect creators, audiences, producers, and venues in an authentic,
          industry-first home.
        </p>
      </div>
      <div className="about-hwa__values">
        {values.map((value) => (
          <div className="about-hwa__value" key={value.title}>
            <h3>{value.title}</h3>
            <p>{value.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
